// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';
// import { NAV_WIDTH_CLOSED } from 'src/layouts/dashboard/nav';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 42,
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.primary,
  // color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  ':hover': {
    color: theme.palette.primary.dark,
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  minWidth: 50,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
